/**
 * MOOJO origin video modal — in-page playback only (no external navigation).
 */
(function () {
  if (window.MoojoVideoModal) return;

  const SELECTOR = '[data-moojo-video-modal]';
  const OPEN_SELECTOR = '[data-moojo-video-open]';
  const RELATED_SELECTOR = '[data-moojo-video-related]';

  function parseTriggers(root) {
    return [...root.querySelectorAll(OPEN_SELECTOR)];
  }

  function getModal() {
    return document.querySelector(SELECTOR);
  }

  function setIframe(modal, embedUrl, title) {
    const frame = modal.querySelector('[data-moojo-video-iframe]');
    const heading = modal.querySelector('[data-moojo-video-modal-title]');
    if (!frame) return;

    frame.src = embedUrl || '';
    frame.title = title || 'Vidéo';
    if (heading) heading.textContent = title || '';
  }

  function setActiveRelated(modal, button) {
    modal.querySelectorAll(RELATED_SELECTOR).forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function openModal(modal, { embedUrl, title, relatedButton }) {
    if (!embedUrl) return;
    setIframe(modal, embedUrl, title);
    if (relatedButton) {
      setActiveRelated(modal, relatedButton);
    } else {
      modal.querySelectorAll(RELATED_SELECTOR).forEach((item) => {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });
    }
    if (typeof modal.showModal === 'function' && !modal.open) {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    document.documentElement.classList.add('moojo-video-modal-open');
  }

  function closeModal(modal) {
    setIframe(modal, '', '');
    modal.querySelectorAll(RELATED_SELECTOR).forEach((item) => {
      item.classList.remove('is-active');
      item.removeAttribute('aria-current');
    });
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    document.documentElement.classList.remove('moojo-video-modal-open');
  }

  function bindModal(modal) {
    if (!modal || modal.dataset.moojoVideoBound === 'true') return;
    modal.dataset.moojoVideoBound = 'true';

    modal.querySelectorAll('[data-moojo-video-close]').forEach((control) => {
      control.addEventListener('click', () => closeModal(modal));
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal(modal);
    });

    modal.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal(modal);
    });

    modal.querySelectorAll(RELATED_SELECTOR).forEach((button) => {
      button.addEventListener('click', () => {
        const embedUrl = button.dataset.moojoVideoEmbed || '';
        const title = button.dataset.moojoVideoTitle || '';
        if (!embedUrl) return;
        openModal(modal, { embedUrl, title, relatedButton: button });
      });
    });
  }

  function bindTriggers(root, modal) {
    parseTriggers(root).forEach((trigger) => {
      if (trigger.dataset.moojoVideoTriggerBound === 'true') return;
      trigger.dataset.moojoVideoTriggerBound = 'true';

      trigger.addEventListener('click', () => {
        const embedUrl = trigger.dataset.moojoVideoEmbed || '';
        const title = trigger.dataset.moojoVideoTitle || '';
        openModal(modal, { embedUrl, title, relatedButton: null });
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        trigger.click();
      });
    });
  }

  function init(scope) {
    const modal = getModal();
    if (!modal) return;
    bindModal(modal);
    bindTriggers(scope || document, modal);
  }

  window.MoojoVideoModal = { init, open: openModal, close: closeModal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
